// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__26f6I","label":"SetPasswdForm_label__3Efzm"};